<template>
  <Dialog
    v-model="errorDetailState.visible"
    :title="t('sys.api.errorDetailTitle')"
    :width="dialogWidth"
  >
    <template v-if="errorDetailState.detail">
      <el-descriptions :column="1" size="small" border>
        <el-descriptions-item :label="t('sys.api.errorNo')">
          {{ errorDetailState.detail.errorNo || "-" }}
        </el-descriptions-item>
        <el-descriptions-item :label="t('sys.api.errorTime')">
          {{ errorDetailState.detail.exceptionTime || "-" }}
        </el-descriptions-item>
        <el-descriptions-item :label="t('sys.api.errorRequest')">
          {{ errorDetailState.detail.requestMethod || "" }} {{ errorDetailState.detail.requestUrl || "-" }}
        </el-descriptions-item>
        <el-descriptions-item :label="t('sys.api.errorPosition')">
          {{ positionText }}
        </el-descriptions-item>
      </el-descriptions>
      <div v-if="errorDetailState.detail.stackTrace" class="error-stack">
        <div class="error-stack-title">{{ t('sys.api.stackTrace') }}</div>
        <pre class="error-stack-content">{{ errorDetailState.detail.stackTrace }}</pre>
      </div>
      <div class="error-tips">{{ t('sys.api.errorDetailTips') }}</div>
    </template>
    <template #footer>
      <ElButton type="primary" @click="handleClose">{{ t('common.close') }}</ElButton>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { errorDetailState } from "./store";

defineOptions({ name: "ErrorDetailDialog" });

const { t } = useI18n();
const isMobile = ref(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
const dialogWidth = computed(() => (isMobile.value ? "96%" : "720px"));

const positionText = computed(() => {
  const detail = errorDetailState.detail;
  if (!detail) {
    return "-";
  }
  if (detail.exceptionFileName && detail.exceptionLineNumber) {
    return `${detail.exceptionFileName}:${detail.exceptionLineNumber}`;
  }
  if (detail.exceptionClassName) {
    return `${detail.exceptionClassName}:${detail.exceptionMethodName || "?"}`;
  }
  return "-";
});

const handleClose = () => {
  errorDetailState.visible = false;
};
</script>

<style lang="scss" scoped>
.error-stack {
  margin-top: 12px;

  .error-stack-title {
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  .error-stack-content {
    max-height: 320px;
    margin: 0;
    padding: 10px;
    overflow: auto;
    font-family: Consolas, Monaco, monospace;
    font-size: 12px;
    line-height: 1.6;
    color: #606266;
    background-color: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    white-space: pre-wrap;
    word-break: break-all;
  }
}

.error-tips {
  margin-top: 12px;
  font-size: 13px;
  color: #e6a23c;
  line-height: 1.6;
}
</style>
